import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { tableConstants } from '..';

export const useTable = <T extends tableConstants.Keys>(props: {
  key: T;
  onSuccess?: (data: tableConstants.Defaults[T]) => void;
}) => {
  const data = useQuery<string>({
    queryKey: [tableConstants.queryKeys.TABLE, props?.key],
    queryFn: async () => {
      const res = await $api.get(`/v1/table/${props?.key}`);

      return res?.data?.data;
    },
    onSuccess: data => {
      if (props?.onSuccess) {
        props?.onSuccess({
          ...tableConstants.defaults[props?.key],
          ...JSON.parse(data || '{}')
        } as tableConstants.Defaults[T]);
      }
    }
  });

  return {
    ...data,
    data: {
      ...tableConstants.defaults[props?.key],
      ...JSON.parse(data?.data || '{}')
    } as tableConstants.Defaults[T]
  };
};
